/**
 * Resolve pricing for a product that may store its price at the top level
 * or inside its first variant.
 *
 * Variant-based products have no top-level price/offerPrice — the Product
 * model's pre-save hook clears them whenever `variants` is non-empty — so any
 * screen that reads `product.price` / `product.offerPrice` directly shows a
 * blank/undefined price for those products. Use this helper instead.
 *
 * @param {Object} product - Product object (may include a `variants` array)
 * @returns {{ price: number, offerPrice: number, effectivePrice: number }}
 */
export const resolveProductPricing = (product) => {
  const hasVariants =
    Array.isArray(product?.variants) && product.variants.length > 0;
  const source = hasVariants ? product.variants[0] : product;
  const price = Number(source?.price) || 0;
  const offerPrice = Number(source?.offerPrice) || 0;
  return {
    price,
    offerPrice,
    effectivePrice: offerPrice > 0 ? offerPrice : price,
  };
};
